import firebase from 'firebase';

// const config = {
//     apiKey: "AIzaSyDoWUhIATq60ZOrDBC03-W7sSkp-usRBWk",
//     authDomain: "test-1c6eb.firebaseapp.com",
//     databaseURL: "https://test-1c6eb.firebaseio.com",
//     projectId: "test-1c6eb",
//     storageBucket: "test-1c6eb.appspot.com",
//     messagingSenderId: "60602324384"
// };
// const config = {
//   apiKey: "AIzaSyDc9BK2MEiO-LRnnm0zwoBSC59ksvfm0Kw",
//   authDomain: "design-bostadsvaljare-ereim.firebaseapp.com",
//   databaseURL: "https://design-bostadsvaljare-ereim.firebaseio.com",
//   projectId: "design-bostadsvaljare-ereim",
//   storageBucket: "design-bostadsvaljare-ereim.appspot.com",
//   messagingSenderId: "920462883994"
// };
// const config = {
//   apiKey: "AIzaSyBDELaqk0MUpJKLRl5kCHOnBJcGYOsloi0",
//   authDomain: "bostadsvaljare-nybrostrand.firebaseapp.com",
//   databaseURL: "https://bostadsvaljare-nybrostrand.firebaseio.com",
//   projectId: "bostadsvaljare-nybrostrand",
//   storageBucket: "bostadsvaljare-nybrostrand.appspot.com",
//   messagingSenderId: "547175464173"
// };

// const config = {
//   apiKey: "AIzaSyCXbYxL6HxdoLcqWSQKtiEgcr1hOUdPf6k",
//   authDomain: "bostadsvaljare-snosparven.firebaseapp.com",
//   databaseURL: "https://bostadsvaljare-snosparven.firebaseio.com",
//   projectId: "bostadsvaljare-snosparven",
//   storageBucket: "bostadsvaljare-snosparven.appspot.com",
//   messagingSenderId: "969552142439"
// };

// const config = {
//   apiKey: "AIzaSyBhwqAqnX1Fht_8rIQ-GAOrVu-0gfw8mI8",
//   authDomain: "gnisvard-ac8df.firebaseapp.com",
//   databaseURL: "https://gnisvard-ac8df.firebaseio.com",
//   projectId: "gnisvard-ac8df",
//   storageBucket: "gnisvard-ac8df.appspot.com",
//   messagingSenderId: "918032915272",
//   measurementId: "G-1JWYGWNXEX"
// };

// const config = {
//   apiKey: "AIzaSyDLNBiyX1uYr-O8De4wGHMbYmvHXpOkz00",
//   authDomain: "angsklockan-954e8.firebaseapp.com",
//   databaseURL: "https://angsklockan-954e8.firebaseio.com",
//   projectId: "angsklockan-954e8",
//   storageBucket: "angsklockan-954e8.appspot.com",
//   messagingSenderId: "815760244364",
//   appId: "1:815760244364:web:ee1e5666810a41e13105a9",
//   measurementId: "G-JX041B0M90"
// };

// const config = {
//   apiKey: "AIzaSyA1SNv9RrhwqUtnx1wtOFN4bjxHV0xA4Po",
//   authDomain: "holmangshage.firebaseapp.com",
//   databaseURL: "https://holmangshage.firebaseio.com",
//   projectId: "holmangshage",
//   storageBucket: "holmangshage.appspot.com",
//   messagingSenderId: "954396375228",
//   appId: "1:954396375228:web:7fc6c1a5c72d7ddccc38b9",
//   measurementId: "G-4JERVKPQ7V"
// };

// const config = {
//   apiKey: "AIzaSyDcRzini5_3lKNoDE4H7n6-qf7X0TLW7h8",
//   authDomain: "falktrasket-447f9.firebaseapp.com",
//   databaseURL: "https://falktrasket-447f9.firebaseio.com",
//   projectId: "falktrasket-447f9",
//   storageBucket: "falktrasket-447f9.appspot.com",
//   messagingSenderId: "725998133533",
//   appId: "1:725998133533:web:5b54db1aafc5ddcb2781f4",
//   measurementId: "G-51D2PJLJBT"
// };

// const config = {
//   apiKey: "AIzaSyDYHvKHUo7ZdsuxYHvzPFP_Xj_XmSdYjls",
//   authDomain: "nordtag-275e6.firebaseapp.com",
//   databaseURL: "https://nordtag-275e6.firebaseio.com",
//   projectId: "nordtag-275e6",
//   storageBucket: "nordtag-275e6.appspot.com",
//   messagingSenderId: "728440512358",
//   appId: "1:728440512358:web:16fe732206aac3729a32a7",
//   measurementId: "G-R6834WSLX2"
// };

// const config = {
//   apiKey: "AIzaSyCJDglJKBTMwta1ifgoMtgkW-DVcWBbs28",
//   authDomain: "angsklockan-etapp-2.firebaseapp.com",
//   databaseURL: "https://angsklockan-etapp-2.firebaseio.com",
//   projectId: "angsklockan-etapp-2",
//   storageBucket: "angsklockan-etapp-2.appspot.com",
//   messagingSenderId: "342260954489",
//   appId: "1:342260954489:web:a604df2b3d98f100c16ba8",
//   measurementId: "G-KZXJ94EN7J"
// };

const config = {
  apiKey: "AIzaSyAeKuPNrPZ9Zy-14qZ0up1dEMdT_iwdo6U",
  authDomain: "torps-gard.firebaseapp.com",
  databaseURL: "https://torps-gard.firebaseio.com",
  projectId: "torps-gard",
  storageBucket: "torps-gard.appspot.com",
  messagingSenderId: "845747006086",
  appId: "1:845747006086:web:f144fd3c2ede5123ae3f07",
  measurementId: "G-WD99YR0TSC"
};

var fire = firebase.initializeApp(config);
export default fire;



// WEBPACK FOOTER //
// ./src/fire.js